/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CanvasArcController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class CanvasArcController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class CanvasArcController extends cls.ControllerBase /** @lends classes.CanvasArcController.prototype */ {
    static __name = "CanvasArcController";

    _initBehaviors() {
      super._initBehaviors();

      this._addBehavior(cls.CanvasArcParametersVMBehavior);
      this._addBehavior(cls.CanvasFillColorVMBehavior);
      this._addBehavior(cls.CanvasItemOnClickUIBehavior);
    }
  }

  cls.CanvasArcController = CanvasArcController;
  cls.ControllerFactory.register("CanvasArc", cls.CanvasArcController);
});
